export enum MODAL_TYPES {
	INSURANCE = "INSURANCE",
	SCREEN_INSURANCE = "SCREEN_INSURANCE",
}
